import EvaluationController from "./evaluationController";

const EvaluationComponent = {
    template: require("./evaluationView.html"),
    controller: EvaluationController,
};

export default EvaluationComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/evaluationComponent.js